<template>
  <div class="zoom-controls">
    <button @click="$emit('zoomIn')" title="Zoom in" class="zoom-btn">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
      </svg>
    </button>
    <button @click="$emit('zoomOut')" title="Zoom out" class="zoom-btn">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M19 13H5v-2h14v2z"/>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
defineEmits<{
  zoomIn: []
  zoomOut: []
}>()
</script>

<style scoped>
.zoom-controls {
  position: absolute;
  right: 16px;
  top: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 20;
}

.zoom-btn {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  backdrop-filter: blur(8px);
}

.zoom-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  border-color: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .zoom-controls {
    right: 12px;
    top: 12px;
  }
  .zoom-btn {
    width: 34px;
    height: 34px;
  }
}

@media (max-width: 480px) {
  .zoom-btn {
    width: 30px;
    height: 30px;
  }
  .zoom-btn svg {
    width: 16px;
    height: 16px;
  }
}
</style>
